import { createApp } from 'vue';
import App from './App.vue';
import { store, key } from './store';
import emitter from '@/utils/emitter';
import VueSmoothScroll from 'vue3-smooth-scroll';

const app = createApp(App).use(store, key).use(VueSmoothScroll);
app.config.globalProperties.emitter = emitter; // Add emmiter
app.mount('#app');
